var map = {
	"./de/R-360HD_CrossSection.png": 473,
	"./en/R-360HD_CrossSection.png": 481,
	"./es/R-360HD_CrossSection.png": 489,
	"./fr/R-360HD_CrossSection.png": 497,
	"./frFR/R-360HD_CrossSection.png": 505
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2979;


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers ^\.\/.*\/R\-360HD_CrossSection\.png$
// module id = 2979
// module chunks = 0